import { NavLink } from 'react-router-dom';
import { cn } from '@/utils/cn';

interface SidebarProps {
  open: boolean;
  isAdmin: boolean;
  onClose: () => void;
}

export function Sidebar({ open, isAdmin, onClose }: Readonly<SidebarProps>) {
  return (
    <>
      {/* Outside-click backdrop; transparent on desktop. */}
      {open && (
        <div
          className="fixed inset-0 z-20 bg-black/30 md:bg-transparent"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      <aside
        aria-label="Main navigation"
        className={cn(
          // Always a fixed overlay — slides in from left, never takes layout space
          'fixed top-12 left-0 bottom-0 z-30 w-52 overflow-y-auto bg-white border-r border-cool-gray-2 transition-transform duration-200',
          open ? 'translate-x-0' : '-translate-x-full',
        )}
      >
        <nav className="flex flex-col py-2">
          <NavLink
            to="/dashboard"
            onClick={onClose}
            className={({ isActive }) =>
              cn(
                'block px-4 py-2 text-sm text-black hover:bg-cool-gray-2',
                isActive && 'font-semibold text-dds-blue bg-cool-gray-2',
              )
            }
          >
            Dashboard
          </NavLink>

          {isAdmin && (
            <NavLink
              to="/user-access-management"
              onClick={onClose}
              className={({ isActive }) =>
                cn(
                  'block px-4 py-2 text-sm text-black hover:bg-cool-gray-2',
                  isActive && 'font-semibold text-dds-blue bg-cool-gray-2',
                )
              }
            >
              User Access Management
            </NavLink>
          )}
        </nav>
      </aside>
    </>
  );
}
